(function() {
    'use strict';

    var $jqw = $(window),
        $jqd = $(document);

    angular
        .module('app.core')
        .run(run);

    /* @ngInject */
    function run($rootScope, $window, $location, $sce) {
        /*
        $rootScope.menu = sitenav;
        angular.forEach($rootScope.menu, function(item, idx) {
            // console.log([idx, item]);
            $rootScope.menu[idx].title = $sce.trustAsHtml(item.title);
            // $rootScope.intro[item.rlnk] = {
            //     'icon': item.intro.icon,
            //     'back': item.intro.back
            // };
        });

        $rootScope.openedNavbar = false;

        $rootScope.$watch('openedNavbar', function(nVal, oVal) { navbarRealign(); }, true);
        $rootScope.$on('debouncedResize', function(e, args) { navbarRealign(); });
        function navbarRealign() {
            if($rootScope.openedNavbar) {
                var $nbc = $('.navbar .container'), $nbu = $('.navbar .container > ul'),
                    nch = $nbc.height(), nuh = $nbu.height(),
                    num = nch > nuh ? (nch - nuh) / 2 : 0;
                $nbu.css({'margin-top': num + 'px'});
            }
        }

        // $jqd.ready(function() {
        //     $jqw.on({
        //         load: function() {},
        //         unload: function() {},
        //         resize: function() {},
        //         scroll: function() {}
        //     });
        // });

        $rootScope.loading = true;

        // console.log(['run @ app.core', document, window]);

        // if(document.readyState === 'complete') {
        //     console.log(['run @ app.core', 'already loaded']);
        // } else {
        //     window.addEventListener('onload', function() {
        //         console.log(['window.onload']);
        //     }, false);
        //     document.addEventListener('DOMContentLoaded', function() {
        //         console.log(['document.DOMContentLoaded']);
        //     }, false);
        // }

        // document.addEventListener('DOMContentLoaded', function(event) {
        //     console.log(['eventListener @ document.ready', event]);
        // });

        // window.addEventListener('load', function(event) {
        //     console.log(['eventListener @ window.load', event]);
        // }, false);

        // window.addEventListener('scroll', function(event) {
        //     console.log(['eventListener @ window.scroll', event]);
        // }, false);

        // window.addEventListener('unload', function(event) {
        //     console.log('I am the 3rd one.');
        // });
        // window.addEventListener("scroll", myScript);
        // window.onscroll = function() {myFunction()};
        // function myFunction() {
        //     if(document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        //         document.getElementById("myP").className = "test";
        //     } else {
        //         document.getElementById("myP").className = "";
        //     }
        // }

        var $jnb = $('.navbar'), $jcc = $('.contact-corner');
        $jqw.scroll(function() {

            // if($jqw.width() > 895 && $jqw.scrollTop() >= $jqw.height() - $jnb.outerHeight()) {
            if($rootScope.rsp.hpd.from && $jqw.scrollTop() >= $jqw.height() - $jnb.outerHeight()) {
                $jnb.addClass('sticky'); $jcc.removeClass('on-main-page');
            } else {
                $jnb.removeClass('sticky'); $jcc.addClass('on-main-page');
            }

            // if($jqw.width() >= 1024 && $jqw.scrollTop() <= $jqw.height()) {
            if($rootScope.rsp.hpd.from && $jqw.scrollTop() <= $jqw.height()) {

                if($jqw.scrollTop() > 0) {
                    $('.limus-page-header .lph-paralax > .fader').css({'z-index': 1});
                } else {
                    $('.limus-page-header .lph-paralax > .fader').css({'z-index': -1});
                }

                if($('.limus-page-header').attr('id') == 'intro') {
                    $('.limus-page-header .lph-paralax > .fader').css({
                        'bottom' : ($jnb.outerHeight() + $jqw.scrollTop() - 52) + 'px'
                    });
                } else {
                    $('.limus-page-header .lph-paralax > .fader').css({
                        'top' : $jnb.outerHeight() + 'px'
                    });
                }

                $('.limus-page-header .lph-paralax > .fader').css({
                    'opacity' : (Math.sqrt($jqw.scrollTop()) / Math.sqrt($jqw.height()))
                });

            }
        });

        var wScrollTop = window.scrollY, wScrollTopL = wScrollTop, winH =  window.innerHeight ,cornerHide = window.innerHeight - $jnb.outerHeight();
        $rootScope.$on('throttledScroll', function(e, args) {
            // console.log(['throttled onScroll', e, args]);
            wScrollTop = window.scrollY;
            mobileNavbarHide();
            contactCornerHide();
        });

        function mobileNavbarHide() {
            if($rootScope.rsp.vpd.to) {
                if(!$rootScope.openedNavbar) {
                    if(wScrollTop > $jnb.outerHeight()) {
                        if(wScrollTop > wScrollTopL) {
                            $jnb.addClass('navbar-hide').removeClass('navbar-show');
                        } else {
                            $jnb.addClass('navbar-show').removeClass('navbar-hide');
                        }
                    }
                }
                wScrollTopL = wScrollTop;
            }
        }

        function contactCornerHide() {
            if($rootScope.rsp.dtp.from && $rootScope.isHome) {
                if(
                    (wScrollTop > $('#contact').offset().top - winH * 0.25) &&
                    (wScrollTop < $('#contact').offset().top + $('#contact').outerHeight()) ||
                    (wScrollTop + 154 >= cornerHide) &&
                    (wScrollTop < cornerHide)
                ) {
                    $('.contact-corner').css('opacity', 0);
                    // console.log(cornerHide);
                } else if(wScrollTop >= cornerHide) {
                    $('.contact-corner').removeClass('on-main-page').css('opacity', 1);
                } else {
                    $('.contact-corner').css('opacity', 1).addClass('on-main-page');
                }
            }
        }
        */

    }

    // function topCornerCheckPage() {
    //     if(is_page =='homepage' && !rsp.ltp.check && !rsp.mbl.check ) {
    //         $('.contact-corner').addClass('on-main-page visible');
    //     } else if(is_page != 'contactpage' && !rsp.ltp.check && !rsp.mbl.check ) {
    //         $('.contact-corner').addClass('visible');
    //     }
    // }

    // function mobileNavbarMenuToggle() {
    //     $('.mobile-toggle').click(function( e ) {
    //         e.preventDefault();
    //         if($jnb.hasClass('navbar-open')) {
    //             $jnb.removeClass('navbar-open');
    //             $('body, html').css({height: '', overflow: ''});
    //             // mobileNavbarListAlign();
    //         } else {
    //             $jnb.addClass('navbar-open');
    //             $('body, html').css({height: '100%', overflow: 'hidden'});
    //             mobileNavbarListAlign();
    //         }
    //         return false;
    //     });
    // }

    // function mobileNavbarMenuOpen() {
    //     if(!$('.navbar').hasClass('navbar-open')) {
    //         $('.navbar').addClass('navbar-open');
    //         $('body, html').css({height: '100%', overflow: 'hidden'});
    //         mobileNavbarListAlign();
    //     }
    // }

    // function mobileNavbarMenuClose() {
    //     if($('.navbar').hasClass('navbar-open')) {
    //         $('.navbar').removeClass('navbar-open');
    //         $('body, html').css({height: '', overflow: ''});
    //     }
    // }

    // function mobileNavbarListAlign() {
    //     if(rsp.apn.check || rsp.vpd.check) {
    //         if($jnb.hasClass('navbar-open')) {
    //             var nch = $('.navbar .container').height(),
    //                 nuh = $('.navbar .container > ul').height(),
    //                 num = nch > nuh ? (nch - nuh)/2 : 0;
    //             $('.navbar .container > ul').css({'margin-top': num+'px'});
    //         }
    //     }
    // }

    // var $win = angular.element($window)[0]; $rootScope.is_sticky = false;
    // $rootScope.scroll = { h: $win.scrollX, v: $win.scrollY };
    // $rootScope.scrollState = function() { return { x: $win.scrollX, y: $win.scrollY }; };
    // $rootScope.$watch($rootScope.scrollState, function(ss) {
    //     $rootScope.scroll = { h: ss.x, v: ss.y };
    //     if(!$rootScope.rsp.mbl.chk && $rootScope.stats && $rootScope.stats.is_home) {
    //         if(ss.y >= $rootScope.win.height - $rootScope.navbarHeight) {
    //             $rootScope.is_sticky = true;
    //         } else {
    //             $rootScope.is_sticky = false;
    //         }
    //     }
    // }, true);

    // $rootScope.navbarHeight = 0;
    // $rootScope.navbarTop = function() {
    //     var calc = $rootScope.win.height - $rootScope.navbarHeight - $rootScope.scroll.v;
    //     return ($rootScope.stats && $rootScope.stats.is_home) ? ((calc <= 0) ? 0 : calc + 'px') : 0;
    // };

    // CRM >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // function crmInit() {
    //     if(isPage == 'limuscrm' || isPage == 'homepage') {
    //         $("#lci-control").on('hover', 'path', function() {
    //             var avi = $('#lci-control path[data-active="true"]').index() + 1,
    //                 tsi = $(this).index() + 1,
    //                 thisId = $(this).attr('id').replace('path_', '');
    //             if((tsi - avi) != 0) {
    //                 var deglost = parseFloat($('#lci-pointer path').data('deg')),
    //                     dti = tsi - avi,
    //                     tpi = 11 - Math.abs(dti),
    //                     way = Math.abs(dti) / tpi >= 1.2 ? -1 * (dti / Math.abs(dti)) : 1 * (dti / Math.abs(dti)),
    //                     step = Math.abs(dti) >= tpi ? tpi : Math.abs(dti),
    //                     degrotate = ((way * (step * 360 / 11)) + deglost).toFixed(2);
    //                 $('#lci-pointer path').data('deg', degrotate).stop().animate(
    //                     { newdeg: degrotate },
    //                     {
    //                         step: function(now, tween) {
    //                             if(tween.prop === "newdeg") {
    //                                 $(this).attr('transform','rotate(' + now + ', 435, 435)');
    //                             }
    //                         },
    //                         start: function() {
    //                             var ti = thisId;
    //                             $('#lci-text .lci-textpath').attr('fill', '#ffffff');
    //                             $('#lci-icons path').attr('fill', '#6e7176');
    //                             $('#lci-text-' + ti).attr('fill','#06a740');
    //                             $('#ici-icons-' + ti + ' path').attr('fill', '#ffffff');
    //                             $('.lc-infographic-circle .lci-' + ti).addClass('active').siblings().removeClass('active');
    //                         },
    //                         complete:  function() {},
    //                         duration: 200
    //                     },
    //                     'ease'
    //                 );
    //             }
    //             $(this).attr('data-active','true').siblings().attr('data-active','false');
    //         });
    //     }
    // }

    // function crmScrollAni() {
    //     $('#lci-pointer path').data('deg', 360).stop().animate({ newdeg: 360 }, { step: function(now, tween) {
    //         if(tween.prop === "newdeg") {
    //             $(this).attr('transform','rotate('+now+', 435, 435)');
    //         }
    //     }, duration: 400}, 'ease');
    // }

    // function crmResize() {
    //     if(is_page == 'limuscrm' || is_page == 'homepage' && !rsp.apn.check) {
    //         var wxh,
    //             sdt = winH - ($('.limus-crm').height() - $('.lc-infographic').height()),
    //             cmc = $('.limus-crm .container').width();
    //         if(sdt < 870 || cmc < 870) {
    //             wxh = sdt > cmc ? cmc : sdt;
    //             if(wxh < 500) {
    //                 wxh = winH*0.8;
    //             }
    //             if(rsp.vpd.check) {
    //                 wxh = cmc*0.8;
    //             }
    //             // wxh = 500;
    //             $('.lc-infographic').css({height: wxh , width: wxh , 'font-size': Math.round(wxh/20)+'px'});
    //             // alert(sdt);
    //         }
    //     }
    // }

    // function actionCRMCarousel() {
    //     if(is_page == 'limuscrm' || is_page == 'homepage' && rsp.apn.check) {
    //         var mobileCRMSlider = $('.lim-inner .swiper-container').swiper({
    //             mode:'horizontal',
    //             speed: 200,
    //             slidesPerView: 5,
    //             calculateHeight: true,
    //             centeredSlides: true,
    //             loop: true,
    //             loopAdditionalSlides: 3,
    //             onSlideChangeEnd: function(swiper) {
    //                 actionCRMCarouselGetTxt($(swiper.activeSlide()));
    //             }
    //         });
    //         $('.lim-arrow').click( function(e) {
    //             e.preventDefault();
    //             switch ($(this).attr('rel')) {
    //                 case 'prev':
    //                     mobileCRMSlider.swipePrev();
    //                     break;
    //                 case 'next':
    //                     mobileCRMSlider.swipeNext();
    //             }
    //             return false;
    //         });
    //         $('.lim-inner .swiper-slide').click( function(e) {
    //             var _index = $(this).data('index');
    //             mobileCRMSlider.swipeTo(_index, 200);
    //         });
    //         actionCRMCarouselGetTxt($('.lim-inner .swiper-slide.swiper-slide-active'));
    //     }
    // }

    // function actionCRMCarouselGetTxt(element) {
    //     var title = element.find('img').data('title'),
    //         descp = element.find('img').data('description');
    //     $('.lic-slide-caption h3').text(title);
    //     $('.lic-slide-caption p').text(descp);
    // }
    // CRM <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

})();